import { whatsappUrl } from "../data/site";

export default function BookNowButton({
  testId,
  label = "Book Now",
  className = "",
}) {
  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`btn ${className}`}
      data-testid={testId}
    >
      {label}
    </a>
  );
}
